module.exports = __webpack_public_path__ + "static/media/AsadoContacto.1d0425ca.jpeg";